import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { UserService } from '../core/user.service';
import { FirebaseUserModel } from '../core/user.model';
import { Library } from '@core/library';

@Injectable()
export class UserResolver implements Resolve<FirebaseUserModel> {

  constructor(
    public userService: UserService,
    private router: Router,
    private library: Library,
  ) { }

  resolve(route: ActivatedRouteSnapshot): Promise<FirebaseUserModel> {

    // tslint:disable-next-line:prefer-const
    let user = new FirebaseUserModel();
    this.library.showloading();
    return new Promise((resolve, reject) => {
      this.userService.getCurrentUser()
      .then(res => {
        return resolve(res);
      }, err => {
        this.router.navigate(['/login']);
        return reject(err);
      }).finally(() => {
        this.library.hideloading();
      });
    });
  }
}
